<template>
  <detail
    :onManager="onManager"
    :data="data"
    :base-info="baseInfo"
    :extraInfo="extraInfo"
    :hiddenKeys="['project_domain', 'tenant', 'status']"
    :show-desc="false"
    :is-edit-name="false" />
</template>

<script>
import {
  getEnabledTableColumn,
  // getSwitchTableColumn
} from '@/utils/common/tableColumn'
import {
  getConfigTypeTableColumn,
  getAttirubuteTableColumn,
} from '../utils/columns'
import { SMS_TPL_ITEMS, parseSmsTplInfo } from '../utils/smsTemplate'
export default {
  name: 'NotifyConfigDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getConfigTypeTableColumn(),
        getAttirubuteTableColumn(),
      ],
      configInfo: {
        email: [
          {
            title: this.$t('system.text_255'),
            items: [
              {
                field: 'hostname',
                title: this.$t('system.text_269'),
                formatter: ({ row }) => {
                  return row.content?.hostname || '-'
                },
              },
              {
                field: 'hostport',
                title: this.$t('system.text_270'),
                formatter: ({ row }) => {
                  return row.content?.hostport || '-'
                },
              },
              {
                field: 'username',
                title: this.$t('system.text_126'),
                formatter: ({ row }) => {
                  return row.content?.username || '-'
                },
              },
              getEnabledTableColumn({ title: 'SSL', field: 'content.ssl_global' }),
              {
                field: 'sender_address',
                title: this.$t('iam.sender_address'),
                formatter: ({ row }) => {
                  return row.content?.sender_address || '-'
                },
              },
            ],
          },
        ],
        mobile: [
          {
            title: this.$t('system.text_255'),
            items: [
              {
                field: 'sms_driver',
                title: this.$t('notify.configs.sms_driver'),
                formatter: ({ row }) => {
                  if (row.content && row.content.sms_driver) {
                    if (row.content.sms_driver === 'smsaliyun') {
                      return this.$t('providers.aliyun')
                    } else if (row.content.sms_driver === 'smshuawei') {
                      return this.$t('providers.huawei')
                    }
                  }
                  return '-'
                },
              },
              {
                field: 'access_key_id',
                title: 'Access Key ID',
                formatter: ({ row }) => {
                  return row.content?.access_key_id || '-'
                },
              },
              {
                field: 'signature',
                title: this.$t('system.text_288'),
                formatter: ({ row }) => {
                  return row.content?.signature || '-'
                },
              },
            ],
          },
        ],
        feishu: [
          {
            title: this.$t('system.text_255'),
            items: [
              {
                field: 'app_id',
                title: 'AppID',
                formatter: ({ row }) => {
                  return row.content?.app_id || '-'
                },
              },
            ],
          },
        ],
        dingtalk: [
          {
            title: this.$t('system.text_255'),
            items: [
              {
                field: 'agent_id',
                title: 'AgentId',
                formatter: ({ row }) => {
                  return row.content?.agent_id || '-'
                },
              },
              {
                field: 'app_key',
                title: 'AppKey',
                formatter: ({ row }) => {
                  return row.content?.app_key || '-'
                },
              },
            ],
          },
        ],
        workwx: [
          {
            title: this.$t('system.text_255'),
            items: [
              {
                field: 'corp_id',
                title: this.$t('system.wecom.corp_id'),
                formatter: ({ row }) => {
                  return row.content?.corp_id || '-'
                },
              },
              {
                field: 'agent_id',
                title: 'AgentId',
                formatter: ({ row }) => {
                  return row.content?.agent_id || '-'
                },
              },
            ],
          },
        ],
      },
      smsTplInfo: {},
    }
  },
  computed: {
    extraInfo () {
      if (this.data.type === 'mobile') {
        return [
          this.configInfo.mobile[0],
          {
            title: this.$t('system.mobile_cn_tpl'),
            items: this.getSmsTplDetailItems('cn'),
          },
          {
            title: this.$t('system.mobile_en_tpl'),
            items: this.getSmsTplDetailItems('en'),
          },
        ]
      }
      return this.configInfo[this.data.type] || []
    },
  },
  created () {
    this.notifytemplatesManager = new this.$Manager('notifytemplates', 'v1')
    this.notifytemplatesSaveManager = new this.$Manager('notifytemplates/save', 'v1')
    this.fetchNotifyTpl()
  },
  destroyed () {
    this.notifytemplatesManager = null
    this.notifytemplatesSaveManager = null
  },
  methods: {
    getSmsTplDetailItems (lang) {
      return SMS_TPL_ITEMS.map(item => {
        const field = lang === 'cn' ? item.detailCn : item.detailEn
        const title = this.$t(item.titleKey)
        return {
          field,
          title,
          slots: {
            default: ({ row }, h) => {
              return [
                h('list-body-cell-wrap', {
                  props: {
                    copy: true,
                    edit: true,
                    field,
                    row: { ...row, ...this.smsTplInfo },
                    message: this.smsTplInfo[field],
                    label: title,
                    showSuccessMessage: false,
                    ok: val => this.saveSmsTpl(item.topic, lang, field, val),
                  },
                }),
              ]
            },
          },
        }
      })
    },
    fetchNotifyTpl () {
      const { type } = this.data
      if (type !== 'mobile') return
      this.notifytemplatesManager.list({ params: { contact_type: type } })
        .then(res => {
          const { data: { data } } = res
          this.smsTplInfo = parseSmsTplInfo(data)
        })
        .catch(err => {
          console.error(err)
        })
    },
    async saveSmsTpl (topic, lang, field, content) {
      const val = (content || '').trim()
      if (!val) {
        this.$message.warning(this.$t('common.placeholder') + this.$t(SMS_TPL_ITEMS.find(i => i.topic === topic).titleKey))
        return
      }
      try {
        await this.notifytemplatesSaveManager.create({
          data: {
            contact_type: 'mobile',
            force: true,
            templates: [{
              contact_type: 'mobile',
              template_type: 'remote',
              topic,
              lang,
              content: val,
            }],
          },
        })
        this.$set(this.smsTplInfo, field, val)
        this.$message.success(this.$t('system.text_301'))
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
